import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EafHttpInterceptor } from 'src/assets/lib/eaf-ng2-module/src/eafHttpInterceptor';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
  providers: [
    ApiServiceProxies.CachingServiceProxy,
    ApiServiceProxies.WebLogServiceProxy,
    ApiServiceProxies.AuditLogServiceProxy,
    ApiServiceProxies.CommonLookupServiceProxy,
    ApiServiceProxies.HostSettingsServiceProxy,
    ApiServiceProxies.LanguageServiceProxy,
    ApiServiceProxies.NotificationServiceProxy,
    ApiServiceProxies.PermissionServiceProxy,
    ApiServiceProxies.ProfileServiceProxy,
    ApiServiceProxies.RoleServiceProxy,
    ApiServiceProxies.SessionServiceProxy,
    ApiServiceProxies.TenantServiceProxy,
    ApiServiceProxies.TimingServiceProxy,
    ApiServiceProxies.UserServiceProxy,
    ApiServiceProxies.UserLoginServiceProxy,
    ApiServiceProxies.AccountServiceProxy,
    ApiServiceProxies.TokenAuthServiceProxy,
    ApiServiceProxies.UiCustomizationSettingsServiceProxy,
    ApiServiceProxies.DynamicSettingsServiceProxy,
    ApiServiceProxies.OccurrenceServiceProxy,
    ApiServiceProxies.BriefingServiceProxy,
    ApiServiceProxies.EventServiceProxy,
    ApiServiceProxies.CommanderServiceProxy,
    ApiServiceProxies.RootThemeServiceProxy,
    ApiServiceProxies.ContinuousImprovementServiceProxy,
    ApiServiceProxies.ArticlesServiceProxy,
    ApiServiceProxies.AirportServiceProxy,
    ApiServiceProxies.OrientationServiceProxy,
    ApiServiceProxies.WorkShiftServiceProxy,
    ApiServiceProxies.ContactServiceProxy,
    ApiServiceProxies.CorridorInformationServiceProxy,
    ApiServiceProxies.ReleaseInformationServiceProxy,
    ApiServiceProxies.ExportServiceProxy,
    ApiServiceProxies.FileServiceProxy,
    ApiServiceProxies.FriendshipServiceProxy,
    ApiServiceProxies.ChatServiceProxy,
    ApiServiceProxies.OperationalTacticalServiceProxy,
    ApiServiceProxies.UsersServiceProxy,
    ApiServiceProxies.FlightMonitoringServiceProxy,
    ApiServiceProxies.BriefingGolServiceProxy,
    ApiServiceProxies.FlightLaunchesServiceProxy,
    ApiServiceProxies.AlertServiceProxy,
    ApiServiceProxies.CostIndexServiceProxy,
    ApiServiceProxies.CostIndexOperationalServiceProxy,
    ApiServiceProxies.NotamServiceProxy,
    ApiServiceProxies.AlternateFlightServiceProxy,
    ApiServiceProxies.MELItemServiceProxy,
    ApiServiceProxies.MELPainelServiceProxy,
    ApiServiceProxies.FlightTimeServiceProxy,
    ApiServiceProxies.BriefingAirportServiceProxy,
    ApiServiceProxies.FirServiceProxy,
    ApiServiceProxies.CityPairServiceProxy,
    ApiServiceProxies.UtilServiceServiceProxy,
    ApiServiceProxies.MinimumsServiceProxy,
    { provide: HTTP_INTERCEPTORS, useClass: EafHttpInterceptor, multi: true },
  ],
})
export class ServiceProxyModule {}
